/* Native links work without JS. Enhancement appends catalogue pages without losing PDP state. */
if (!customElements.get('duryn-product-catalog')) customElements.define('duryn-product-catalog', class extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    this.addEventListener('click', event => {
      const next = event.target.closest('[data-catalog-next]');
      if (!next || !this.contains(next) || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      this.load(next);
    }, { signal: this.controller.signal });
  }

  async load(link) {
    if (this.busy) return;
    this.busy = true;
    const controller = this.controller;
    const status = this.querySelector('[data-catalog-status]');
    const grid = this.querySelector('[data-catalog-grid]');
    grid.setAttribute('aria-busy', 'true');
    link.setAttribute('aria-disabled', 'true');
    status.textContent = this.dataset.loading;
    try {
      const url = new URL(link.href, window.location.href);
      if (url.origin !== window.location.origin) throw new Error('Unexpected catalog origin');
      url.hash = '';
      const currentUrl = new URL(window.location.href);
      for (const key of ['view', 'preview_theme_id']) {
        if (!url.searchParams.has(key) && currentUrl.searchParams.has(key)) url.searchParams.set(key, currentUrl.searchParams.get(key));
      }
      url.searchParams.set('section_id', this.dataset.sectionId);
      const response = await fetch(url, { signal: controller.signal });
      if (!response.ok) throw new Error('Catalog request failed');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const catalog = doc.getElementById(this.id);
      if (!catalog?.querySelector('[data-catalog-grid]')) throw new Error('Missing catalog content');
      const cards = catalog.querySelectorAll('[data-catalog-grid] > .dg-product-card');
      if (controller.signal.aborted || !this.isConnected) return;
      const existing = new Set([...grid.children].map(card => card.dataset.productId));
      let firstNew;
      for (const card of cards) {
        if (existing.has(card.dataset.productId)) continue;
        existing.add(card.dataset.productId);
        firstNew ||= card;
        grid.append(card);
      }
      const pagination = this.querySelector('[data-catalog-pagination]');
      const newPagination = catalog.querySelector('[data-catalog-pagination]');
      if (newPagination?.querySelector('[data-catalog-next]')) {
        newPagination.querySelectorAll('a:not([data-catalog-next])').forEach(previous => previous.remove());
        pagination.replaceWith(newPagination);
      }
      else pagination?.remove();
      status.textContent = '';
      firstNew?.focus({ preventScroll: true });
      firstNew?.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'nearest' });
    } catch (error) {
      if (error.name !== 'AbortError' && this.isConnected && this.controller === controller) status.textContent = this.dataset.error;
    } finally {
      if (this.controller === controller) {
        this.busy = false;
        grid.removeAttribute('aria-busy');
        link.removeAttribute('aria-disabled');
      }
    }
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.controller = null;
    this.busy = false;
    this.querySelector('[aria-busy]')?.removeAttribute('aria-busy');
    this.querySelector('[aria-disabled]')?.removeAttribute('aria-disabled');
  }
});
